import { createFileRoute } from '@tanstack/react-router';
import { endOfMonth, startOfMonth } from 'date-fns';
import { Camera } from 'lucide-react';
import { useState } from 'react';
import AuthGuard from '@/components/auth-guard';
import type { PeriodSelection } from '@/components/dashboard/period-selector';
import { PeriodSelector } from '@/components/dashboard/period-selector';
import { TransactionList } from '@/components/dashboard/transaction-list';
import { OCRUploadModal } from '@/components/ocr/ocr-upload-modal';
import { Button } from '@/components/ui/button';

export const Route = createFileRoute('/transactions')({
  component: TransactionsPage,
});

function TransactionsPage() {
  const today = new Date();
  const [selectedPeriod, setSelectedPeriod] = useState<PeriodSelection>({
    type: 'current',
    startDate: startOfMonth(today),
    endDate: endOfMonth(today),
    label: 'Mês atual',
  });
  const [ocrModalOpen, setOcrModalOpen] = useState(false);

  return (
    <AuthGuard requireAuth={true}>
      <div className="container mx-auto space-y-6 px-4 py-6">
        <div className="flex items-center justify-between gap-4">
          <h1 className="font-bold text-2xl">Transações</h1>
          <div className="flex flex-1 items-center gap-3">
            <div className="flex-1">
              <PeriodSelector
                onPeriodChange={setSelectedPeriod}
                selectedPeriod={selectedPeriod}
              />
            </div>
            <Button onClick={() => setOcrModalOpen(true)} variant="outline">
              <Camera className="mr-2 h-4 w-4" />
              Extrair Extrato
            </Button>
          </div>
        </div>

        <TransactionList selectedPeriod={selectedPeriod} />

        <OCRUploadModal
          onOpenChange={setOcrModalOpen}
          onSuccess={() => {
            // Refresh transaction list or handle success
            window.location.reload(); // Simple refresh for now
          }}
          open={ocrModalOpen}
        />
      </div>
    </AuthGuard>
  );
}
